export const routingPathsConstants = {
  LOGIN: {
    path: '/login'
  },
  REDIRECT_MESSAGE: {
    path: '/redirect-message'
  },
  CONGRATS: {
    path: '/successfull-payment'
  },
  PAYMENTKO: {
    path: '/payment-ko'
  },
  WELCOME: {
    path: '/welcome'
  },
  DASHBOARD: {
    path: '/dashboard',
    id: 'dashboard'
  },
  NOTIFICATIONS: {
    path: '/notifications',
    id: 'notifications'
  },
  SELL: {
    path: '/sell',
    id: 'sell'
  },
  SELL_W_POS: {
    path: '/sell/pos-payment',
    id: 'sell'
  },
  SELL_CONTRACTUALIZE_SELLING: {
    path: '/sell/contractualize-selling',
    id: 'sell'
  },
  SELL_TRANSACTION_OK: {
    path: '/sell/transaction-ok',
    id: 'sell'
  },
SELL_TRANSACTION_KO: {
    path: '/sell/transaction-ko',
    id: 'sell'
  },
  CUSTOMERS: {
    path: '/customers',
    id: 'customers'
  },
  CUSTOMERS_FILTERED: {
    path: '/customers/new-subscribers',
    id: 'customers'
  },
  EDIT_CUSTOMER: {
    path: '/customers/edit-customer',
    id: 'customers'
  },
  RECEIPS: {
    path: '/receipts',
    id: 'receipts'
  },
  REGISTRY: {
    path: '/registry',
    id: 'registry'
  },
  NEW_REGISTRY_GATEWAY: {
    path: '/registry/new-gateway',
    id: 'registry'
  },
  LOCAL_UNITS: {
    path: '/local-units',
    id: 'local_units'
  },
  EDIT_UNIT: {
    path: '/local-units/edit-unit',
    id: 'local_units'
  },
  USERS: {
    path: '/users',
    id: 'users'
  },
  NEW_USERS: {
    path: '/users/create-user',
    id: 'users'
  },
  STATISTICS: {
    path: '/statistics',
    id: 'statistics'
  },
  PAYMENTS: {
    path: '/payments',
    id: 'payments'
  },
  SERVICES: {
    path: '/services',
    id: 'services'
  },
  REQUEST_SUPPORT: {
    path: '/request-support',
    id: 'request_support'
  },
  NEW_REQUEST_SUPPORT: {
    path: '/request-support/new-request',
    id: 'request_support'
  },
  PRODUCTS_CATALOG: {
    path: '/products-catalog',
    id: 'products_catalog'
  },
  PRODUCTS_CATALOG_NEW_PRODUCT: {
    path: '/products-catalog/new-product',
    id: 'products_catalog'
  },
  PRODUCTS_CATALOG_NEW_GENERIC_PRODUCT: {
    path: '/products-catalog/new-generic-product',
    id: 'products_catalog'
  },
  MANAGE_USERS: {
    path: '/manage-user',
    id: 'manage_user'
  },
  EDIT_MERCHANT: {
    path: '/registry/edit-merchant',
    id: 'registry'
  },
  INSOLVENT_MERCHANT: { path: '/boot/insolvent' },
  PDF_ACCEPTER: { path: '/boot/pdf-accepter' },
  SELL_IFRAME: { path: '/sell/payment-make-up', id: 'sell' },
  BOOT: { path: '/boot' },
  GATEWAYS: { path: '/gateways' },
};
